import { withRouter } from 'react-router-dom';
import Tbl from './Tbl.js';
import FilterChips from './FilterChips.js';
import FilterBlock from './FilterBlock.js';
import WithSystem from './../service/WithSystem';

class OverAllReport extends React.Component {
  constructor(props) {
    super(props);
    let contentDisplay = window.localStorage.getItem(
      'consoidatedReportContentDisplay'
    )
      ? JSON.parse(
          window.localStorage.getItem('consoidatedReportContentDisplay')
        )
      : {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true,
          6: true,
          7: true,
          8: true,
          9: true,
          10: true,
          11: true,
        };
    if (!window.localStorage.getItem('consoidatedReportContentDisplay')) {
      window.localStorage.setItem(
        'consoidatedReportContentDisplay',
        JSON.stringify(contentDisplay)
      );
    }
    this.state = {
      GlobalState: window.queryFilter,
      searchkey: this.getQueryStringValue('searchkey'),
      startdate: false,
      enddate: false,
      demo: false,
      keywords: this.getQueryStringValue('keywords'),
      filtershow: false,
      contentDisplay,
      showFilter: this.props.filterToggle,
    };
  }
  componentDidMount() {
    this.contentDisplayChecked();
  }
  getQueryStringValue = (key) => {
    var encoded_URI = this.props.location.search.replace(
      new RegExp(
        '^(?:.*[&\\?]' +
          encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') +
          '(?:\\=([^&]*))?)?.*$',
        'i'
      ),
      '$1'
    );
    var parseData = decodeURIComponent(encoded_URI);
    if (parseData == '' || parseData == null) {
      return false;
    }
    return parseData;
  };
  componentDidUpdate() {}
  componentWillUnmount() {}
  contentDisplayChecked = () => {
    let contentDispayObject = window.localStorage.getItem(
      'consoidatedReportContentDisplay'
    )
      ? JSON.parse(
          window.localStorage.getItem('consoidatedReportContentDisplay')
        )
      : {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true,
          6: true,
          7: true,
          8: true,
          9: true,
          10: true,
          11: true,
        };
    if (Object.keys(contentDispayObject).length) {
      for (const [key, value] of Object.entries(contentDispayObject)) {
        document.getElementById('bc_column_' + key).checked = value;
      }
    }
  };
  contentDisplay = (e) => {
    let contentDispayObject = window.localStorage.getItem(
      'consoidatedReportContentDisplay'
    )
      ? JSON.parse(
          window.localStorage.getItem('consoidatedReportContentDisplay')
        )
      : {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true,
          6: true,
          7: true,
          8: true,
          9: true,
          10: true,
          11: true,
        };
    contentDispayObject[e.target.getAttribute('data-column')] = e.target.checked
      ? true
      : false;
    window.localStorage.setItem(
      'consoidatedReportContentDisplay',
      JSON.stringify(contentDispayObject)
    );
    this.setState({ contentDisplay: contentDispayObject });
  };
  bookMarking = () => {
    this.props.history.push(window.bookMarkings());
  };
  getSearchKeyword = (evt) => {
    this.props.setGlobalState({ searchkey: evt.target.value });
  };
  datacallback = (paramdata) => {};
  render() {
    return (
      <div>
        <div className="container-fluid">
          <div className="leaner-progrs-header rTable w-100">
            <div className="rTableRow-align">
              <div className="rTableCell">
                <div className="d-flex align-center">
                  <span className="leaner-back-btn">
                    <a href={`${admin_url}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={20}
                        height={20}
                        viewBox="0 0 23 24.241"
                      >
                        <g
                          id="Icon_feather-arrow-left"
                          data-name="Icon feather-arrow-left"
                          transform="translate(1.5 2.121)"
                        >
                          <path
                            id="Path_221"
                            data-name="Path 221"
                            d="M27.5,18H7.5"
                            transform="translate(-7.5 -8)"
                            fill="none"
                            stroke="#2e3e4e"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={3}
                          />
                          <path
                            id="Path_222"
                            data-name="Path 222"
                            d="M18,27.5,7.5,17.5,18,7.5"
                            transform="translate(-7.5 -7.5)"
                            fill="none"
                            stroke="#2e3e4e"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={3}
                          />
                        </g>
                      </svg>
                    </a>
                  </span>
                  <div>
                    <h4>Learners Progress Report</h4>
                    <p>
                      This report provides an overview of learners' activity in
                      your course such as course progress, course start date,
                      and completion date, etc.
                    </p>
                  </div>
                </div>
              </div>
              <div className="rTableCell">
                <div
                  className="float-r learner-report-export-txt"
                  onClick={() => window.exportConsolidateReport()}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15.737"
                    height="13.267"
                    viewBox="0 0 15.737 13.267"
                  >
                    <g
                      id="Group_139"
                      data-name="Group 139"
                      transform="translate(-1259.4 -40)"
                    >
                      <path
                        id="Path_28"
                        data-name="Path 28"
                        d="M2.674,5.284h7.534a.423.423,0,0,1,.419.428v5.135h1.256V5.712A1.693,1.693,0,0,0,10.208,4H2.674A1.693,1.693,0,0,0,1,5.712v9.843a1.693,1.693,0,0,0,1.674,1.712h7.534a1.682,1.682,0,0,0,1.621-1.284H10.417q-.075,0-.149,0a.409.409,0,0,1-.06,0H2.674a.423.423,0,0,1-.419-.428V5.712A.423.423,0,0,1,2.674,5.284Z"
                        transform="translate(1258.4 36)"
                        fill="#2e3e4e"
                        fillRule="evenodd"
                        opacity="0.8"
                      />
                      <path
                        id="Union_1"
                        data-name="Union 1"
                        d="M-7926.283-1216.05v-.728h-2.364a1.352,1.352,0,0,1-1.354-1.351,1.354,1.354,0,0,1,1.354-1.353h2.364v-1.065a.452.452,0,0,1,.712-.368l3.165,2.249a.451.451,0,0,1,0,.734l-3.165,2.251a.447.447,0,0,1-.259.083A.452.452,0,0,1-7926.283-1216.05Z"
                        transform="translate(9197.354 1266.51)"
                        fill="#2e3e4e"
                        opacity="0.8"
                      />
                      <path
                        id="Path_30"
                        data-name="Path 30"
                        d="M9.979,11.852h-1.8a.676.676,0,0,1,0-1.352h1.8a.676.676,0,0,1,0,1.352Z"
                        transform="translate(1254.647 31.266)"
                        fill="#2e3e4e"
                        opacity="0.8"
                      />
                      <path
                        id="Path_31"
                        data-name="Path 31"
                        d="M9.979,16.852h-1.8a.676.676,0,0,1,0-1.352h1.8a.676.676,0,0,1,0,1.352Z"
                        transform="translate(1254.647 28.394)"
                        fill="#2e3e4e"
                        opacity="0.8"
                      />
                      <path
                        id="Path_32"
                        data-name="Path 32"
                        d="M9.979,21.852h-1.8a.676.676,0,1,1,0-1.352h1.8a.676.676,0,1,1,0,1.352Z"
                        transform="translate(1254.647 25.521)"
                        fill="#2e3e4e"
                        opacity="0.8"
                      />
                      <path
                        id="Path_33"
                        data-name="Path 33"
                        d="M9.979,26.852h-1.8a.676.676,0,1,1,0-1.352h1.8a.676.676,0,1,1,0,1.352Z"
                        transform="translate(1254.647 22.649)"
                        fill="#2e3e4e"
                        opacity="0.8"
                      />
                    </g>
                  </svg>
                  Export
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="leaner-info-tab-sec">
          <div className="container-fluid">
            <div className="align-center d-flex justify-between leaner-info-report-details">
              <div className="d-flex">
                <div className="d-flex border-right pad-right30">
                  <div className="leaner-rounded-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.803"
                      height="15.747"
                      viewBox="0 0 18.803 15.747"
                    >
                      <g
                        id="Group_25"
                        data-name="Group 25"
                        transform="translate(-39.2 -126.128)"
                      >
                        <path
                          id="Path_213"
                          data-name="Path 213"
                          d="M13.761,23.442V21.878a3.128,3.128,0,0,0-3.128-3.128H4.378A3.128,3.128,0,0,0,1.25,21.878v1.564"
                          transform="translate(38.75 117.633)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.6"
                        />
                        <path
                          id="Path_214"
                          data-name="Path 214"
                          d="M12.505,6.878A3.128,3.128,0,1,1,9.378,3.75,3.128,3.128,0,0,1,12.505,6.878Z"
                          transform="translate(36.878 123.25)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.6"
                        />
                        <path
                          id="Path_215"
                          data-name="Path 215"
                          d="M27.346,23.5V21.939A3.128,3.128,0,0,0,25,18.913"
                          transform="translate(29.857 117.572)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.6"
                        />
                        <path
                          id="Path_216"
                          data-name="Path 216"
                          d="M20,3.913a3.128,3.128,0,0,1,0,6.06"
                          transform="translate(31.729 123.189)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.6"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="leaner-report-subtxt">
                    <p>Total Learners</p>
                    <span id="Tlearners">0</span>
                  </div>
                </div>
                <div className="d-flex border-right pad-left30 pad-right30">
                  <div className="leaner-rounded-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.076"
                      height="20.076"
                      viewBox="0 0 20.076 20.076"
                    >
                      <g
                        id="Group_16"
                        data-name="Group 16"
                        transform="translate(-261 -124)"
                      >
                        <path
                          id="Path_217"
                          data-name="Path 217"
                          d="M863.552,54.485l2.893,2.837,6.929-6.793"
                          transform="translate(-597.115 79.745)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeWidth="1.6"
                        />
                        <g
                          id="Path_218"
                          data-name="Path 218"
                          transform="translate(261 124)"
                          fill="none"
                        >
                          <path
                            d="M10.038,0A10.038,10.038,0,1,1,0,10.038,10.038,10.038,0,0,1,10.038,0Z"
                            stroke="none"
                          />
                          <path
                            d="M 10.03803062438965 1.599998474121094 C 5.385280609130859 1.599998474121094 1.600000381469727 5.385288238525391 1.600000381469727 10.03803825378418 C 1.600000381469727 14.69078826904297 5.385280609130859 18.47607803344727 10.03803062438965 18.47607803344727 C 14.69078063964844 18.47607803344727 18.47606086730957 14.69078826904297 18.47606086730957 10.03803825378418 C 18.47606086730957 5.385288238525391 14.69078063964844 1.599998474121094 10.03803062438965 1.599998474121094 M 10.03803062438965 -1.9073486328125e-06 C 15.58188056945801 -1.9073486328125e-06 20.0760612487793 4.49417781829834 20.0760612487793 10.03803825378418 C 20.0760612487793 15.5818977355957 15.58188056945801 20.07607841491699 10.03803062438965 20.07607841491699 C 4.494180679321289 20.07607841491699 0 15.5818977355957 0 10.03803825378418 C 0 4.49417781829834 4.494180679321289 -1.9073486328125e-06 10.03803062438965 -1.9073486328125e-06 Z"
                            stroke="none"
                            fill="#2d71fd"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="leaner-report-subtxt">
                    <p>Completed</p>
                    <span id="Tcompleted">0</span>
                  </div>
                </div>
                <div className="d-flex pad-left30">
                  <div className="leaner-rounded-box">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18.744"
                      height="20.533"
                      viewBox="0 0 18.744 20.533"
                    >
                      <g
                        id="Group_48"
                        data-name="Group 48"
                        transform="translate(-238.378 -97.75)"
                      >
                        <path
                          id="Ellipse_6"
                          data-name="Ellipse 6"
                          d="M6.76.563a6.2,6.2,0,1,0,6.2,6.2,6.2,6.2,0,0,0-6.2-6.2M6.76,0A6.76,6.76,0,1,1,0,6.76,6.76,6.76,0,0,1,6.76,0Z"
                          transform="translate(240.411 98)"
                          fill="#2d71fd"
                          stroke="#2d71fd"
                          strokeWidth="0.5"
                        />
                        <path
                          id="Ellipse_7"
                          data-name="Ellipse 7"
                          d="M4.507.563A3.943,3.943,0,1,0,8.45,4.507,3.948,3.948,0,0,0,4.507.563m0-.563A4.507,4.507,0,1,1,0,4.507,4.507,4.507,0,0,1,4.507,0Z"
                          transform="translate(242.665 100.253)"
                          fill="#2d71fd"
                          stroke="#2d71fd"
                          strokeWidth="0.5"
                        />
                        <path
                          id="Path_222"
                          data-name="Path 222"
                          d="M-404.8,49.714a.282.282,0,0,1-.263-.181l-1.039-2.7h-2.984a.282.282,0,0,1-.248-.149.282.282,0,0,1,.014-.289l3.749-5.6.468.313-3.455,5.164h2.65a.282.282,0,0,1,.263.181l.818,2.126,1.9-6.1.538.168-2.143,6.873a.282.282,0,0,1-.26.2Z"
                          transform="translate(648 68.319)"
                          fill="#2d71fd"
                          stroke="#2d71fd"
                          strokeWidth="0.5"
                        />
                        <path
                          id="Path_223"
                          data-name="Path 223"
                          d="M-392.343,49.553a.282.282,0,0,1-.252-.157l-3.252-6.577.505-.25,2.9,5.867.563-2.479a.282.282,0,0,1,.332-.213l2.745.572-4.421-5.213.43-.364,4.952,5.838a.282.282,0,0,1,.027.326.282.282,0,0,1-.3.132l-3.277-.683-.678,2.982a.282.282,0,0,1-.242.217Z"
                          transform="translate(644.635 68.332)"
                          fill="#2d71fd"
                          stroke="#2d71fd"
                          strokeWidth="0.5"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="leaner-report-subtxt">
                    <p>Total Certifications</p>
                    <span id="Tcertifications">0</span>
                  </div>
                </div>
              </div>
              <div className="align-center d-flex">
                <div className="dataTables_filter pad-right40">
                  <i className="icon icon-search datatable-searchicon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14.46"
                      height="14.46"
                      viewBox="0 0 14.46 14.46"
                    >
                      <path
                        id="Path_230"
                        data-name="Path 230"
                        d="M13.458,7.792A5.667,5.667,0,1,1,7.792,2.125a5.667,5.667,0,0,1,5.667,5.667Z"
                        transform="translate(-1.417 -1.417)"
                        fill="none"
                        stroke="#2e3e4e"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.417"
                      />
                      <path
                        id="Path_231"
                        data-name="Path 231"
                        d="M14.875,14.875l-3.081-3.081"
                        transform="translate(-1.417 -1.417)"
                        fill="none"
                        stroke="#2e3e4e"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.417"
                      />
                    </svg>
                  </i>
                  <input
                    onInput={this.getSearchKeyword}
                    type="search"
                    className="bc-search"
                    autoComplete="off"
                    placeholder="Search by Learner & Email"
                    aria-controls="bc-datatable"
                    value={
                      this.props.queryFilter.searchkey
                        ? this.props.queryFilter.searchkey
                        : ''
                    }
                    id="searchkey"
                  />
                </div>
                <div
                  className={
                    this.state.showFilter
                      ? 'leaner-report-filter active'
                      : 'leaner-report-filter'
                  }
                  onClick={() =>
                    this.setState({ showFilter: !this.state.showFilter })
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.833"
                    height="11.667"
                    viewBox="0 0 12.833 11.667"
                  >
                    <path
                      id="Icon_feather-filter"
                      data-name="Icon feather-filter"
                      d="M12.833,1.75H1.167L5.833,7.268v3.815L8.167,12.25V7.268Z"
                      transform="translate(-0.583 -1.167)"
                      fill="none"
                      stroke="#2e3e4e"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.167"
                    />
                  </svg>
                  Filter
                </div>
                <div className="dropdown bc-column-selector">
                  <div
                    className="dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <span>...</span>
                  </div>
                  <ul className="dropdown-menu">
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="0"
                          onClick={this.contentDisplay}
                          data-column-name="Learner Name"
                          data-field-name="cs_user_name"
                          type="checkbox"
                          vlaue=""
                          id="bc_column_0"
                        />
                        Leaner Name
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="1"
                          onClick={this.contentDisplay}
                          data-column-name="Email Id"
                          type="checkbox"
                          data-field-name="cs_user_email"
                          vlaue=""
                          id="bc_column_1"
                        />
                        Email ID
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="2"
                          onClick={this.contentDisplay}
                          data-column-name="Branch"
                          type="checkbox"
                          data-field-name="cs_user_institute_code"
                          vlaue=""
                          id="bc_column_2"
                        />
                        Branch
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="3"
                          onClick={this.contentDisplay}
                          data-column-name="Course Name"
                          type="checkbox"
                          data-field-name="cs_course_tittle"
                          vlaue=""
                          id="bc_column_3"
                        />
                        Course Name
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="4"
                          onClick={this.contentDisplay}
                          data-column-name="Price"
                          type="checkbox"
                          data-field-name="cs_currency_price"
                          vlaue=""
                          id="bc_column_4"
                        />
                        Price
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="5"
                          onClick={this.contentDisplay}
                          data-column-name="Course Progress"
                          type="checkbox"
                          data-field-name="cs_percentage"
                          vlaue=""
                          id="bc_column_5"
                        />
                        Course Progress
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="6"
                          onClick={this.contentDisplay}
                          data-column-name="Date of Enrollment"
                          type="checkbox"
                          data-field-name="cs_subscription_date"
                          vlaue=""
                          id="bc_column_6"
                        />
                        Date of Enrollment
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="7"
                          onClick={this.contentDisplay}
                          data-column-name="Completion Date"
                          type="checkbox"
                          data-field-name="cs_end_date"
                          vlaue=""
                          id="bc_column_7"
                        />
                        Completion Date
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="8"
                          onClick={this.contentDisplay}
                          data-column-name="Time Spend"
                          type="checkbox"
                          data-field-name="cs_total_duration"
                          vlaue=""
                          id="bc_column_8"
                        />
                        Time Spend
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="9"
                          onClick={this.contentDisplay}
                          data-column-name="Grade"
                          type="checkbox"
                          data-field-name="cs_user_grade"
                          vlaue=""
                          id="bc_column_9"
                        />
                        Grade
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="10"
                          onClick={this.contentDisplay}
                          data-column-name="Certifications Received"
                          type="checkbox"
                          data-field-name="cs_certificate_issued"
                          vlaue=""
                          id="bc_column_10"
                        />
                        Certifications Received
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="11"
                          onClick={this.contentDisplay}
                          data-column-name="UUID"
                          type="checkbox"
                          data-field-name="us_uuid"
                          vlaue=""
                          id="bc_column_11"
                        />
                        UUID
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="12"
                          onClick={this.contentDisplay}
                          data-column-name="Certificate Status"
                          type="checkbox"
                          data-field-name="certificate_status"
                          vlaue=""
                          id="bc_column_12"
                        />
                        Certificate Status
                      </label>
                    </li>
                    <li>
                      <label>
                        <input
                          className="bc_column_visible bc_initial_events"
                          data-column="13"
                          onClick={this.contentDisplay}
                          data-column-name="Certificate Expiry Date"
                          type="checkbox"
                          data-field-name="lcrt_expired_date"
                          vlaue=""
                          id="bc_column_13"
                        />
                        Certificate Expiry Date
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FilterChips filters={{ ...this.state }}> </FilterChips>
        {this.state.showFilter && (
          <FilterBlock datacall={this.datacallback} filters={{ ...this.state }}>
            {' '}
          </FilterBlock>
        )}
        <Tbl data={[]} name={'nameSet'} filters={{ ...this.state }} />
      </div>
    );
  }
}
export default WithSystem(withRouter(OverAllReport));
